import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import { interpret } from "xstate";
import { PAWorkFlowSearchModel } from "@/store/models/paWorkFlow/paWorkFlowSearchData";
import DeleteComponent from "@/components/deleteComponent.vue";
import workFlowListingMachine from "./machines/workFlowListingMachine";
import { PAWorkFlowModule } from "@/store/modules/paWorkFlow.module";
import WorkflowComponent from "./components/WorkflowComponent.vue";
import WorkflowDetailViewComponent from "./components/WorkflowDetailViewComponent.vue";
import _ from "lodash";
let WorkflowListing = /** @class */ (() => {
    let WorkflowListing = class WorkflowListing extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Workflow";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Workflows",
                    active: true,
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.searchData = new PAWorkFlowSearchModel();
            this.workFlowId = "";
            this.columns = [
                {
                    field: "name",
                    label: "Workflow Name",
                    thClass: "workflow-name",
                    filterOptions: {
                        enabled: true,
                        placeholder: "Search Workflow",
                        autoComplete: "off",
                    },
                },
                {
                    field: "empty",
                    label: "",
                    thClass: "",
                    sortable: false,
                },
                {
                    field: "workFlowUsuageCount",
                    label: "Usage Count",
                    thClass: "workflow-count",
                    sortable: false,
                },
                {
                    field: "status",
                    label: "Status",
                    thClass: "workflow-status",
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "workflow-action",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "name",
                    type: "none",
                },
                page: 1,
                pageSize: 10,
            };
            this.totalCount = 0;
            // Selected workflows across all pages: id -> isArchived.
            this.selectedWorkFlows = {};
            this.selectOptions = {
                enabled: true,
                selectOnCheckboxOnly: true,
                selectAllByPage: true,
                disableSelectInfo: true,
            };
            //   MACHINE
            this.machine = workFlowListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            this.machineService.send({ type: "GETTING_WORKFLOWS", searchData: searchData });
        }
        get rows() {
            // vgtSelected re-ticks rows selected on another page when they come back into view.
            return PAWorkFlowModule.workFlows.map((x) => ({ ...x, vgtSelected: this.selectedWorkFlows.hasOwnProperty(x.id.toString()) }));
        }
        get selectedCount() {
            return Object.keys(this.selectedWorkFlows).length;
        }
        get selectedActiveIds() {
            return Object.keys(this.selectedWorkFlows).filter((id) => !this.selectedWorkFlows[id]);
        }
        get selectedArchivedIds() {
            return Object.keys(this.selectedWorkFlows).filter((id) => this.selectedWorkFlows[id]);
        }
        // The grid only reports the current page's selection, so only this page's ids are replaced.
        onSelectionChanged(params) {
            const pageIds = this.rows.map((x) => x.id.toString());
            const selected = { ...this.selectedWorkFlows };
            pageIds.forEach((id) => delete selected[id]);
            params.selectedRows.forEach((x) => (selected[x.id.toString()] = !!x.isArchived));
            if (!_.isEqual(selected, this.selectedWorkFlows)) {
                this.selectedWorkFlows = selected;
            }
        }
        clearSelection() {
            this.selectedWorkFlows = {};
        }
        bulkArchiveWorkFlows(isArchive) {
            const ids = isArchive ? this.selectedActiveIds : this.selectedArchivedIds;
            if (ids.length == 0) {
                return;
            }
            let isPageChanged = this.isAnyFilterApplied && this.serverParams.page !== 1 && this.rows.every((x) => ids.includes(x.id.toString()));
            this.machineService.send({ type: "BULK_ARCHIVE_WORKFLOWS", workFlowIds: ids, isArchived: isArchive, ispageChanged: isPageChanged });
        }
        get stauts() {
            return PAWorkFlowModule.status.map((x) => x.code);
        }
        get totalWorkFlows() {
            return PAWorkFlowModule.totalCount;
        }
        get createdOn() {
            return PAWorkFlowModule.createdOnAsString;
        }
        get workflow() {
            return PAWorkFlowModule.workFlow;
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        // vue-good-table leaves the filter row's checkbox cell unclassed, so the checkbox-column styles miss it.
        tagFilterCheckboxCell() {
            const ecgrid = this.$refs.ecgrid;
            const filterRow = ecgrid?.$refs?.grid?.$refs?.["table-header-primary"]?.$refs?.["filter-row"]?.$el;
            filterRow?.querySelector?.("th, td")?.classList.add("vgt-checkbox-col");
        }
        archiveWorkFlow(id) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.machineService.send({ type: "ARCHIVE_WORKFLOW", workFlowId: id, isArchived: true, ispageChanged: isPageChanged });
        }
        unarchiveWorkFlow(id) {
            let isPageChanged = this.isAnyFilterApplied && this.rows.length === 1 && this.serverParams.page !== 1;
            this.machineService.send({ type: "ARCHIVE_WORKFLOW", workFlowId: id, isArchived: false, ispageChanged: isPageChanged });
        }
        editWorkFlow(workflowId) {
            this.workFlowId = workflowId;
            this.showWorkflow("Edit");
        }
        showWorkflow(mode) {
            let workflowComponent = this.$refs["workflowComponent"];
            workflowComponent.showModal(mode, this.workFlowId);
        }
        showAddWorkflow() {
            this.showWorkflow("Add");
        }
        cloneWorkFlow(workflowId) {
            this.workFlowId = workflowId;
            this.showWorkflow("Clone");
        }
        removeWorkFlow(id) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.workFlowId = id;
            this.machineService.send({ type: "DELETE_WORKFLOW", ispageChanged: isPageChanged });
        }
        deleteWorkFlow() {
            this.machineService.send({ type: "DELETING_WORKFLOW", workFlowId: this.workFlowId });
        }
        onRowClick(params) {
            // vue-good-table also raises row-click from its checkbox; ticking a row must not open the view.
            if (params.event?.target?.closest?.(".vgt-checkbox-col")) {
                return;
            }
            this.workFlowId = params.row.id;
            this.machineService.send({ type: "VIEW_WORKFLOW", workFlowId: this.workFlowId });
        }
        closeViewModal() {
            this.machineService.send({ type: "CANCEL_WORKFLOW" });
        }
        NeedRefresh() {
            this.serverParams.columnFilters.name = "";
            this.serverParams.columnFilters.status = "";
            this.serverParams.page = this.initialPage;
            this.serverParams.pageSize = this.initialPageSize;
            this.clearSelection();
            this.loadItems();
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("loadedWorkFlows")) {
                    this.totalCount = this.totalWorkFlows;
                    this.isGridLoading = false;
                    this.workFlowId = "";
                    var itemTypeColumn = this.columns.find((x) => x.field == "status");
                    if (itemTypeColumn && itemTypeColumn.filterOptions.filterDropdownItems.length == 0) {
                        itemTypeColumn.filterOptions.filterDropdownItems = this.stauts;
                    }
                }
                if (this.state.matches("gettingWorkFlows") || this.state.matches("archivingWorkFlow") || this.state.matches("bulkArchivingWorkFlows")) {
                    this.isGridLoading = true;
                }
                if (this.state.matches("gettingWorkFlows") &&
                    (previousState.matches("archivingWorkFlow") || previousState.matches("bulkArchivingWorkFlows") || previousState.matches("deletingWorkFlow"))) {
                    this.clearSelection();
                }
                if (this.state.matches("viewingWorkFlow")) {
                    let workflowdetailComponent = this.$refs["workflowDetailComponent"];
                    workflowdetailComponent.showModal();
                }
                if ((this.state.matches("gettingWorkFlows") && previousState.matches("deletingWorkFlow")) ||
                    (this.state.matches("gettingWorkFlows") && previousState.matches("archivingWorkFlow")) ||
                    (this.state.matches("gettingWorkFlows") && previousState.matches("bulkArchivingWorkFlows"))) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        updated() {
            this.tagFilterCheckboxCell();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    WorkflowListing = __decorate([
        Component({
            name: "WorkflowListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
                WorkflowComponent,
                WorkflowDetailViewComponent,
            },
        })
    ], WorkflowListing);
    return WorkflowListing;
})();
export default WorkflowListing;
